import { render, staticRenderFns } from "./verticalTable.vue?vue&type=template&id=509b06f2&"
import script from "./verticalTable.vue.js?vue&type=script&lang=js&"
export * from "./verticalTable.vue.js?vue&type=script&lang=js&"
import style0 from "./verticalTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports